import { produccionSections } from './produccionSections';

export const produccionManual = {
  id: 'mod-produccion',
  title: 'Producción',
  isVisible: (ctx) => ctx.canSeeProduccionGeneral,
  intro:
    'Recetas y clasificación, fichas técnicas, guías de producto terminado y en proceso, líneas de producción (si están habilitadas) y reportes de dashboard y uso de insumo. Documentación completa con plantilla de 12 apartados.',
  sections: produccionSections,
};
